import { Link } from "react-router-dom";
import Seo from "@/components/site/Seo";
import RFQForm from "@/components/site/RFQForm";

export default function SourcingRequest() {
  return (
    <div className="min-h-screen bg-nx-bg text-nx-ink" data-testid="page-sourcing-request">
      <Seo
        title="Submit a Sourcing Requirement"
        description="Tell NEXORIQ what you need to source — product, part number, specification, drawing. 48-hour response window; same-day for urgent scope."
        path="/sourcing-request"
      />

      {/* Hero */}
      <section className="bg-nx-navydark text-nx-bg px-6 md:px-12 lg:px-20 pt-32 md:pt-40 pb-16" data-testid="sr-hero">
        <div className="font-mono text-[0.65rem] uppercase tracking-[0.28em] text-nx-copper mb-6">Sourcing Request</div>
        <h1 className="font-cabinet font-black tracking-[-0.04em] leading-[0.92] text-[13vw] md:text-[7vw] lg:text-[5.5vw] text-nx-bg max-w-4xl">
          Tell us what you need to source.
        </h1>
        <p className="mt-6 max-w-2xl text-nx-bg/70 leading-relaxed">
          The more you share, the faster we can respond. Standard reply window is 48 hours; urgent
          requirements are same-day.
        </p>
      </section>

      {/* Form + side rail */}
      <section className="px-6 md:px-12 lg:px-20 py-14 grid grid-cols-1 lg:grid-cols-12 gap-10">
        <div className="lg:col-span-8 border border-nx-navy p-6 md:p-10 bg-white" data-testid="sr-form-card">
          <div className="flex items-center justify-between mb-8">
            <p className="font-mono text-[0.65rem] uppercase tracking-[0.24em] text-nx-copper">
              → Request for Quote
            </p>
            <p className="font-mono text-[0.65rem] uppercase tracking-[0.24em] text-nx-steel2">
              NX / RFQ / 01
            </p>
          </div>
          <RFQForm />
        </div>

        <aside className="lg:col-span-4 lg:pl-8 lg:border-l lg:border-nx-navy/20" data-testid="sr-summary">
          <div className="font-mono text-[0.62rem] uppercase tracking-[0.24em] text-nx-copper mb-4">What happens next</div>
          <ol className="space-y-6">
            {[
              ["Acknowledgement", "You'll get a confirmation from our sourcing desk."],
              ["Global search", "We identify qualified suppliers in relevant markets."],
              ["Options presented", "You receive shortlisted supplier + quotation options."],
              ["Execution support", "We coordinate procurement and delivery when you're ready."],
            ].map(([k, v], i) => (
              <li key={k} className="grid grid-cols-[auto_1fr] gap-4">
                <span className="w-6 h-6 flex items-center justify-center bg-nx-navy text-nx-bg font-mono text-[0.6rem]">{i + 1}</span>
                <div>
                  <div className="font-cabinet font-black text-nx-navy">{k}</div>
                  <div className="text-sm text-nx-navy2">{v}</div>
                </div>
              </li>
            ))}
          </ol>

          <div className="mt-10 border-t border-nx-navy/20 pt-6 text-sm text-nx-navy2">
            Prefer email? <a href="mailto:source@nexoriq.co" className="nx-underline text-nx-navy">source@nexoriq.co</a>
          </div>
          <div className="mt-2 text-sm text-nx-navy2">
            Or <Link to="/contact" className="nx-underline text-nx-navy">reach the sourcing team directly</Link>.
          </div>
        </aside>
      </section>
    </div>
  );
}
